import React, { useState } from "react";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Row,
  Col,
  Modal,
} from "antd";
import { FormInstance } from "antd/es/form";
import styled from "@emotion/styled";
import { TopBar } from "screens/helper-prices/top-bar";
import { HelperPrice } from "screens/helper-prices/helper-price";
import { useDebounce, useDocumentTitle, cleanObject } from "utils";

import { Profiler } from "components/profiler";
import {
  useHelperPositions,
  useAddHelperPosition,
  useEditHelperPosition,
} from "../../utils/helper-position";
import PageContainer from "../../components/layout/PageContainer";

export const HelperPricesScreen = () => {
  useDocumentTitle("helper rank price list", false);

  const helperPriceFormRef = React.createRef<FormInstance>();
  const [helperPriceForm] = Form.useForm();
  const [showHelperPriceModal, setShowHelperPriceModal] = useState(false);

  const [helperPriceData, setHelperPriceData] = useState({
    uuid: null,
    type: 0,
    name: "",
    description: "",
    helper1: null,
    helper2: null,
    helper3: null,
    helper4: null,
    helper5: null,
    helper6: null,
    helper7: null,
    helper8: null,
    helper9: null,
    helper10: null,
    helper11: null,
    helper12: null,
    employer1: null,
    employer2: null,
    employer3: null,
    employer4: null,
    employer5: null,
    employer6: null,
    employer7: null,
    employer8: null,
    employer9: null,
    employer10: null,
    employer11: null,
    employer12: null,
  });

  const [param, setParam] = useState({});
  const { isLoading, error, data, retry } = useHelperPositions(
    useDebounce(param, 200)
  );

  const {
    mutate: addMutate,
    isLoading: addLoading,
    isError: isAddError,
    isSuccess: isAddSuccess,
  } = useAddHelperPosition();
  const {
    mutate: editMutate,
    isLoading: editLoading,
    isError: isEditError,
    isSuccess: isEditSuccess,
  } = useEditHelperPosition();

  const [activeTab, setActiveTab] = useState("1");

  const handleAddNewPriceClick = () => {
    setHelperPriceData({
      uuid: null,
      type: activeTab === "1" ? 0 : 1,
      name: "",
      description: "",
      helper1: null,
      helper2: null,
      helper3: null,
      helper4: null,
      helper5: null,
      helper6: null,
      helper7: null,
      helper8: null,
      helper9: null,
      helper10: null,
      helper11: null,
      helper12: null,
      employer1: null,
      employer2: null,
      employer3: null,
      employer4: null,
      employer5: null,
      employer6: null,
      employer7: null,
      employer8: null,
      employer9: null,
      employer10: null,
      employer11: null,
      employer12: null,
    });
    helperPriceForm.setFieldsValue({
      uuid: null,
      type: activeTab === "1" ? 0 : 1,
      name: "",
      description: "",
      helper1: null,
      helper2: null,
      helper3: null,
      helper4: null,
      helper5: null,
      helper6: null,
      helper7: null,
      helper8: null,
      helper9: null,
      helper10: null,
      helper11: null,
      helper12: null,
      employer1: null,
      employer2: null,
      employer3: null,
      employer4: null,
      employer5: null,
      employer6: null,
      employer7: null,
      employer8: null,
      employer9: null,
      employer10: null,
      employer11: null,
      employer12: null,
    });
    setShowHelperPriceModal(true);
  };

  const handleEditPriceClick = (priceData: any) => {
    setHelperPriceData(priceData);
    helperPriceForm.setFieldsValue(priceData);
    setShowHelperPriceModal(true);
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const handleHelperPriceModalCancel = () => {
    setShowHelperPriceModal(false);
  };

  const handleHelperPriceModalSubmit = async (values: any) => {
    if (helperPriceData.uuid) {
      await editMutate(values);
    } else {
      const data1 = {
        ...values,
        type: 0,
      };
      const data2 = {
        ...values,
        type: 1,
      };
      await Promise.all([
        addMutate(cleanObject(data1)),
        addMutate(cleanObject(data2)),
      ]);
    }
    retry();
    setShowHelperPriceModal(false);
  };

  return (
    <Profiler id={"helper rank price list"}>
      <PageContainer>
        <TopBar
          activeTab={activeTab}
          tabChange={handleTabChange}
          handleAddNewPriceClick={handleAddNewPriceClick}
        />

        {activeTab === "1" && (
          <ContentContainer>
            <HelperPrice
              positionData={data?.list?.filter((item) => item.type === 0) || []}
              handleEditPriceClick={handleEditPriceClick}
            />
          </ContentContainer>
        )}

        {activeTab === "2" && (
          <ContentContainer>
            <HelperPrice
              positionData={data?.list?.filter((item) => item.type === 1) || []}
              handleEditPriceClick={handleEditPriceClick}
            />
          </ContentContainer>
        )}
      </PageContainer>

      <Modal
        title={helperPriceData.uuid ? "edit the helper class price" : "added helper class price"}
        visible={showHelperPriceModal}
        footer={null}
        onCancel={() => handleHelperPriceModalCancel()}
      >
        <Form
          form={helperPriceForm}
          ref={helperPriceFormRef}
          layout="vertical"
          // initialValues={helperPriceData}
          onFinish={handleHelperPriceModalSubmit}
        >
          <Form.Item name="uuid" label="uuid" hidden>
            <Input placeholder="uuid" />
          </Form.Item>

          {/* <Form.Item
            name="type"
            label="類型"
            rules={[{ required: true, message: "please enter 類型" }]}
          >
            <Select placeholder="類型">
              <Select.Option value={0}>私人護理</Select.Option>
              <Select.Option value={1}>院舍護理</Select.Option>
            </Select>
          </Form.Item> */}

          <Form.Item
            name="name"
            label="rank"
            rules={[{ required: true, message: "please enter a rank" }]}
          >
            <Input placeholder="rank" />
          </Form.Item>

          <Form.Item name="description" label="description">
            <Input placeholder="description" />
          </Form.Item>

          <Row>
            <Col span={12}>
              <Form.Item
                name="helper1"
                label="helper 1 hour price"
                rules={[{ required: true, message: "please enter the price for 1 hour" }]}
              >
                <InputNumber placeholder="1 hour price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer1"
                label="employer 1 hour price"
                rules={[{ required: true, message: "please enter the price for 1 hour" }]}
              >
                <InputNumber placeholder="1 hour price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper2"
                label="helper2 hourly price"
                rules={[{ required: true, message: "please enter 2 hourly price" }]}
              >
                <InputNumber placeholder="2 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer2"
                label="employer 2 hourly price"
                rules={[{ required: true, message: "please enter 2 hourly price" }]}
              >
                <InputNumber placeholder="2 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper3"
                label="helper3 hourly price"
                rules={[{ required: true, message: "please enter 3 hourly price" }]}
              >
                <InputNumber placeholder="3 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer3"
                label="employer 3 hourly price"
                rules={[{ required: true, message: "please enter 3 hourly price" }]}
              >
                <InputNumber placeholder="3 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper4"
                label="helper4 hourly price"
                rules={[{ required: true, message: "please enter 4 hourly price" }]}
              >
                <InputNumber placeholder="4 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer4"
                label="employer 4 hourly price"
                rules={[{ required: true, message: "please enter 4 hourly price" }]}
              >
                <InputNumber placeholder="4 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper5"
                label="helper5 hourly price"
                rules={[{ required: true, message: "please enter 5 hourly price" }]}
              >
                <InputNumber placeholder="5 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer5"
                label="employer 5 hourly price"
                rules={[{ required: true, message: "please enter 5 hourly price" }]}
              >
                <InputNumber placeholder="5 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper6"
                label="helper6 hourly price"
                rules={[{ required: true, message: "please enter 6 hourly price" }]}
              >
                <InputNumber placeholder="6 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer6"
                label="employer 6 hourly price"
                rules={[{ required: true, message: "please enter 6 hourly price" }]}
              >
                <InputNumber placeholder="6 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper7"
                label="helper7 hourly price"
                rules={[{ required: true, message: "please enter 7 hourly price" }]}
              >
                <InputNumber placeholder="7 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer7"
                label="employer 7 hourly price"
                rules={[{ required: true, message: "please enter 7 hourly price" }]}
              >
                <InputNumber placeholder="7 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper8"
                label="helper8 hourly price"
                rules={[{ required: true, message: "please enter 8 hourly price" }]}
              >
                <InputNumber placeholder="8 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer8"
                label="employer 8 hourly price"
                rules={[{ required: true, message: "please enter 8 hourly price" }]}
              >
                <InputNumber placeholder="8 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper9"
                label="helper9 hourly price"
                rules={[{ required: true, message: "please enter 9 hourly price" }]}
              >
                <InputNumber placeholder="9 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer9"
                label="employer 9 hourly price"
                rules={[{ required: true, message: "please enter 9 hourly price" }]}
              >
                <InputNumber placeholder="9 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper10"
                label="helper10 hourly price"
                rules={[{ required: true, message: "please enter 10 hourly price" }]}
              >
                <InputNumber placeholder="10 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer10"
                label="employer 10 hourly price"
                rules={[{ required: true, message: "please enter 10 hourly price" }]}
              >
                <InputNumber placeholder="10 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper11"
                label="helper11 hourly price"
                rules={[{ required: true, message: "please enter 11 hourly price" }]}
              >
                <InputNumber placeholder="11 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer11"
                label="employer 11 hourly price"
                rules={[{ required: true, message: "please enter 11 hourly price" }]}
              >
                <InputNumber placeholder="11 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="helper12"
                label="helper12 hourly price"
                rules={[{ required: true, message: "please enter 12 hourly price" }]}
              >
                <InputNumber placeholder="12 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="employer12"
                label="employer 12 hourly price"
                rules={[{ required: true, message: "please enter 12 hourly price" }]}
              >
                <InputNumber placeholder="12 hourly price" style={{ width: 200 }} />
              </Form.Item>
            </Col>
          </Row>

          <Button
            htmlType="button"
            onClick={() => handleHelperPriceModalCancel()}
            style={{ marginRight: 20, marginTop: 20 }}
          >
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </Modal>
    </Profiler>
  );
};

const ContentContainer = styled.div`
  margin-top: 3px;
  // padding: 3.2rem;
  padding: 2rem;
  flex-direction: column;
  position: relative;
  overflow: auto;
`;

HelperPricesScreen.whyDidYouRender = false;
